import React from "react";
import styles from "./SeeMoreLink.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  link: string;
};
const SeeMoreLink: React.FC<Props> = ({ link }) => {
  return (
    <SonicLink to={link} className={styles["seeMore-link-wrapper"]}>
      <div className={styles["seeMore-link"]}>
        <span className={styles["seeMore-link__text"]}>MORE</span>
        <span className={styles["seeMore-link__arrow"]}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
    </SonicLink>
  );
};

export default SeeMoreLink;
